<template>
  <section class="timeline-description">
    <ElTable
      v-if="events.length"
      :data="events"
      :dir="dir"
      :show-header="false"
    >
      <ElTableColumn prop="title" width="250">
        <template slot-scope="{ row: { title, slug } }">
          <i class="material-icons timeline-description__icon">
            {{ getIconBySlug(slug) }}
          </i>
          <span class="timeline-description__title">{{ title }}</span>
        </template>
      </ElTableColumn>
      <ElTableColumn prop="description" />
      <ElTableColumn prop="date" :align="dateAlignment" width="150" />
    </ElTable>
  </section>
</template>

<script>
import dir from '@/mixins/store-getters/dir';

export default {
  name: 'TimelineDescription',
  mixins: [dir],
  props: {
    events: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dateAlignment() {
      return this.dir === 'rtl' ? 'left' : 'right';
    },
  },
  methods: {
    getIconBySlug(slug) {
      const icons = {
        'change-basic-info': 'edit',
        'change-screenshots': 'insert_photo',
        'change-cover': 'panorama',
        'remove-cover': 'panorama',
        'change-icon': 'stars',
        'unpublish-app-manual': 'phonelink_erase',
        'publish-release-manual': 'system_update',
        'publish-release': 'system_update',
        'publish-app': 'system_update',
        'publish-package': 'system_update',
        'publish-package-manual': 'system_update',
        'publish-app-manual': 'publish',
        'remove-video-shot': 'video_library',
        'change-video-shot': 'video_library',
        'change-app-price': 'monetization_on',
      };
      return icons[slug] || '';
    },
  },
};
</script>

<style lang="scss">
.timeline-description {
  padding-left: $global-padding / 2;

  .el-table__row {
    &:first-child td {
      border-top: 1px solid $lb-lighter-gray;
    }

    td {
      padding: $global-padding / 3;
      font-size: rem-calc(12);
      border-bottom: 1px solid $lb-lighter-gray;

      &.is-left {
        text-align: left;
      }
    }
  }

  &__icon {
    margin-left: $global-margin / 3;
    font-size: rem-calc(15);
  }

  &__title {
    font-weight: 600;
  }
}
</style>
